// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ThreeComp_wrapper__524qA"};